// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"50425e1a","998":"6e08818f"}[chunkId] + ".chunk.js";
};